<base-site-layout #dialogContainer [isDialog]="true" (dialogCloseClicked)="close()">
<base-site-layout-header>
<h3 class="base-site-layout-heading m-0">
  <em class="fas fa-boxes"></em>
  ➟
  <em class="fas fa-box-open pe-1"></em>
  {{ 'Einlagerung' | translate }}: {{ dialogTitle }}
</h3>
</base-site-layout-header>
<div class="container-fluid">
  @if (currentItem) {
    <div class="row mb-2">
      <div class="col">
        <document-item [imagePreview]="true">
          <document-item-name>
            {{ currentItem.name }}
          </document-item-name>
          <document-item-description>
            <div class="description-content">
              @if (!showFullDescription) {
                <span>{{ descriptionPreview }}</span>
              }
              @if (showFullDescription) {
                <span>{{ currentItem.shortDescription }}</span>
              }
            </div>
            @if (currentItem.shortDescription && currentItem.shortDescription.length > 200) {
              <span
                type="button"
                class="cursor-pointer hoverable text-primary"
                (click)="toggleDescription()"
                >
                {{
                showFullDescription
                ? ('Weniger anzeigen' | translate)
                : ('Mehr anzeigen' | translate)
                }}
              </span>
            }
          </document-item-description>
          <document-item-attribute>
            <document-item-label>
              {{ 'Art. Nr. Lieferant' | translate }}
            </document-item-label>
            <document-item-value>
              {{ currentItem.articleNumberSupplier }}
            </document-item-value>
          </document-item-attribute>
        </document-item>
      </div>
    </div>
  }

  <separator>{{ 'Einlagerung' | translate }}</separator>

  <div class="row">
    <div class="col">
      <!-- Insert Component -->
      @if (insertData) {
        <div class="insert-component-container">
          <insert-single-product-into-warehouse
            #insertComponent
            [data]="insertData"
            (success)="onInsertionSuccess($event)"
            (cancelled)="onInsertionCancelled()"
          ></insert-single-product-into-warehouse>
        </div>
      }
    </div>
  </div>
</div>
</base-site-layout>
